import { Accordion, AccordionDetails, AccordionSummary, Checkbox } from "@material-ui/core";
import { makeStyles, TableCell, withStyles } from "@material-ui/core";

export const IconStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            cursor: "pointer",
            color: "#2e77ff",
        },
        '&:hover svg': {
            color: "#2e77ff",
        }
    },
    panel: {
        display: "flex",
        justifyContent: "left",
        '& >*:not(:last-child)': {
            marginRight: "20px"
        }
    },
    panelActionsSpaceLastItem: {
        display: "flex",
        justifyContent: "left",
        '& >*:not(:last-child)': {
            marginRight: "20px"
        },
        '& >*:last-child': {
            marginLeft: 20
        }
    }
}));

export const PaginationStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "center"
    },
}));

export const StyledTableCell = withStyles((theme) => ({
    head: {
        padding: '16px 4px',
        fontSize: 15,
    },
    body: {
        padding: '16px 4px',
        fontSize: 14,
    },
}))(TableCell);

export const TableColumnstyles = makeStyles((theme) => ({
    actions: {
        minWidth: 95,
        '&> svg': {
            marginRight: 10,
        }
    },
    actionsSpaceLastItem: {
        minWidth: 95,
        '&> svg': {
            marginRight: 20,
        },
        '&> *:last-child': {
            marginLeft: 15,
        }
    },
    url: {
        minWidth: 100,
        maxWidth: 300,
        wordBreak: "break-word"
    },
    date: {
        minWidth: 90
    }
}));

export const ModalStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        maxWidth: "800px",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        maxHeight: 'calc(100vh - 200px)'
    },
}));

export const CardStyles = makeStyles({
    content: {
        borderBottom: "2px solid grey",
        '&:last-child': {
            paddingBottom: 20,
            paddingTop: 20,
        }
    },
});

export const TableWebsiteStyles = makeStyles({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        "&> *:not(:last-child)": {
            marginRight: 15,
        }
    },
    root: {
        border: "1px solid rgba(224, 224, 224, 1)",
        marginBottom: 10,
        width: "auto",
        '& td': {
            padding: "4px 8px",
        },
        '& th': {
            padding: "4px 8px"
        }
    },
});

export const FieldSetStyles = makeStyles({
    container: {
        border: "1px solid rgba(0, 0, 0, 0.27)",
        borderRadius: 4,
        paddingTop: 2,
        paddingBottom: 4,
    },
});

export const StatFieldset = makeStyles((theme) => ({
    root: {
        position: "relative",
        top: -10,
        paddingBottom: 1,
        paddingTop: 2,
        border: "1px solid rgba(224, 224, 224, 1)",
    },
}));

export const IconLeftExpansionPanelSummary = withStyles({
    root: {
        padding: 0,
        boxShadow: "initial",
        '&:before': {
            display: "none"
        },
        position: "absolute",
        // top: -85,
        right: 10,
    },
    expandIcon: {
        order: -1,
        marginRight: 10,
        padding: "0",
    },
})(AccordionSummary);

export const AdvSettingsPanelSummary = withStyles({
    root: {
        padding: '10px 0 0 0'
    }
})(AccordionDetails);

export const AdvSettingsAccordion = withStyles({
    root: {
        margin: '16px 0 0 0',
        minHeight: 'initial',
        padding: 0,
        boxShadow: 'initial',
        '&:before': {
            display: "none"
        },
        '& .MuiAccordionSummary-root': {
            minHeight: 'initial',
        },
        '& .MuiAccordionSummary-content': {
            margin: 0,
        }
    },
    expanded: {
        marginTop: 0,
    }
})(Accordion);

export const CheckboxSmall = withStyles((theme) => ({
    root: {
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingRight: '3px',
    },
}))(Checkbox);

export const FieldSetWrapper = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
}));

export const CustomMultiFormControl = makeStyles((theme) => ({
    root: {
        marginRight: 20,
    },
}));